<template>
  <div id="pp" class="container mb-48">
    <div class="document-previewer-wrapper-04553d">
       <div data-custom-class="body">
          <h1 class="mt-32 mb-2">
            Privacy Policy
          </h1>
          <p style="font-size:15px;">
             <span style="color: rgb(127, 127, 127);">
                 <span data-custom-class="subtitle">
                    Last updated
                    <span class="question">July 14, 2020</span>
                    &nbsp;
                 </span>
                &nbsp;
             </span>
          </p>
          <p style="font-size: 15px; line-height: 0.5;"><br></p>
          <p style="font-size: 15px; line-height: 0.5;"><br></p>
          <p style="font-size: 15px; line-height: 0.5;"><br></p>
          <p style="font-size: 15px;">
             <span style="color: rgb(89, 89, 89);">
                <span data-custom-class="body_text">
                   Thank you for visiting our site at
                   <span class="question">FirstOptionsFertility</span>
                   <span class="block-component"></span>
                   (“
                   <span class="block-component"></span>
                   company
                   <span class="statement-end-if-in-editor"></span>
                   ”, “we”, “us”, or “our”). We are committed to protecting your personal information and your right to privacy. If you have any questions or concerns about our policy, or our practices with regards to your personal information, please contact us at
                   <span class="question">info@firstoptionsfertility.ie</span>
                   .<br><br>
                </span>
             </span>
          </p>
          <p style="font-size: 15px;">
             <span style="color: rgb(89, 89, 89);">
                <span data-custom-class="body_text">
                   When you visit our
                   <span class="block-component"></span>
                   website
                   <span class="question"><a href="https://firstoptionsfertility.ie" target="_blank" data-custom-class="link">https://firstoptionsfertility.ie</a></span>
                   ,
                   <span class="statement-end-if-in-editor"></span>
                   <span class="block-component"></span>
                   and use our services, you trust us with your personal information. We take your privacy very seriously. In this privacy notice, we describe our privacy policy. We seek to explain to you in the clearest way possible what information we collect, how we use it and what rights you have in relation to it. We hope you take some time to read through it carefully, as it is important. If there are any terms in this privacy policy that you do not agree with, please discontinue use of our
                   <span class="block-component"></span>
                   Sites
                   <span class="statement-end-if-in-editor"></span>
                   <span class="block-component"></span>
                   <span class="block-component"></span>
                   and our services.
                </span>
             </span>
          </p>
          <br>
          <p style="font-size: 15px;">
             <span style="color: rgb(89, 89, 89);">
                <span data-custom-class="body_text">
                   This privacy policy applies to all information collected through our
                   <span class="block-component"></span>
                   <span class="forloop-component"></span>
                   <span class="question">website</span>
                   <span class="forloop-component"></span>
                   (such as
                   <span class="question"><a href="https://firstoptionsfertility.ie" target="_blank" data-custom-class="link">https://firstoptionsfertility.ie</a></span>
                   ),
                   <span class="statement-end-if-in-editor"></span>
                   <span class="block-component"></span>
                   and/or any related services, sales, marketing or events (we refer to them collectively in this privacy policy as the "<strong>Sites</strong>").&nbsp;
                </span>
             </span>
          </p>
          <p style="font-size: 15px;"><span style="color: rgb(89, 89, 89);"><strong><span data-custom-class="body_text">Please read this privacy policy carefully as it will help you make informed decisions about sharing your personal information with us.&nbsp;</span></strong>&nbsp;</span></p>
          <p style="font-size:15px;"><span style="color: rgb(89, 89, 89);"><br></span></p>
          <h3 class="mt-12 mb-2">Table of Contents</h3>
          <p style="font-size:15px;">
             <a data-custom-class="link" href="#infocollect"><span style="color: rgb(89, 89, 89);">1. WHAT INFORMATION DO WE COLLECT?</span></a>
             <span style="color: rgb(89, 89, 89);">
                <span class="block-component"></span>
             </span>
          </p>
          <p style="font-size:15px;">
             <a data-custom-class="link" href="#infouse"><span style="color: rgb(89, 89, 89);">2. HOW DO WE USE YOUR INFORMATION?</span></a>
             <span style="color: rgb(89, 89, 89);">
                <span style="color: rgb(89, 89, 89);">
                   <span class="statement-end-if-in-editor"></span>
                </span>
             </span>
          </p>
          <p style="font-size:15px;">
             <span style="color: rgb(89, 89, 89);"><a data-custom-class="link" href="#infoshare">3. WILL YOUR INFORMATION BE SHARED WITH ANYONE?</a></span>
             <span style="color: rgb(89, 89, 89);">
                &nbsp;
                <span style="color: rgb(89, 89, 89);">
                   <span class="block-component"><span data-custom-class="body_text"></span></span>
                </span>
             </span>
             <span style="font-size: 15px; color: rgb(89, 89, 89);">
                &nbsp;
                <span class="block-component"></span>
                &nbsp;
             </span>
          </p>
          <p style="font-size:15px;">
             <a data-custom-class="link" href="#cookies"><span style="font-size: 15px; color: rgb(89, 89, 89);">4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</span></a>
          </p>
          <p style="font-size:15px;"><a data-custom-class="link" href="#inforetain"><span style="color: rgb(89, 89, 89);">5. HOW LONG DO WE KEEP YOUR INFORMATION?</span></a></p>
          <p style="font-size:15px;">
             <a data-custom-class="link" href="#infosafe"><span style="color: rgb(89, 89, 89);">6. HOW DO WE KEEP YOUR INFORMATION SAFE?</span></a>
             <span style="color: rgb(89, 89, 89);">
                &nbsp;
                <span class="block-component"></span>
                &nbsp;
             </span>
          </p>
          <p style="font-size:15px;">
             <a data-custom-class="link" href="#infominors"><span style="color: rgb(89, 89, 89);">7. DO WE COLLECT INFORMATION FROM MINORS?</span></a>
             <span class="statement-end-if-in-editor"></span>
             &nbsp;
          </p>
          <p style="font-size:15px;"><a data-custom-class="link" href="#privacyrights"><span style="color: rgb(89, 89, 89);">8. WHAT ARE YOUR PRIVACY RIGHTS?</span></a></p>
          <p style="font-size:15px;"><a data-custom-class="link" href="#DNT"><span style="color: rgb(89, 89, 89);">9. CONTROLS FOR DO-NOT-TRACK FEATURES</span></a><span style="color: rgb(89, 89, 89);">&nbsp;</span></p>
          <p style="font-size:15px;"><a data-custom-class="link" href="#caresidents"><span style="color: rgb(89, 89, 89);">10. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</span></a><span style="color: rgb(89, 89, 89);">&nbsp;</span></p>
          <p style="font-size:15px;"><a data-custom-class="link" href="#policyupdates"><span style="color: rgb(89, 89, 89);">11. DO WE MAKE UPDATES TO THIS POLICY?</span></a></p>
          <p style="font-size:15px;"><a data-custom-class="link" href="#contact"><span style="color: rgb(89, 89, 89);">12. HOW CAN YOU CONTACT US ABOUT THIS POLICY?</span></a></p>
          <p style="font-size:15px;"><span style="color: rgb(89, 89, 89);"><br></span></p>

          <p id="infocollect" class="mt-20" style="font-size:15px;"><span style="color: rgb(0, 0, 0);"><strong><span style="font-size: 19px;"><span data-custom-class="heading_1">1. WHAT INFORMATION DO WE COLLECT?</span></span>&nbsp;</strong>&nbsp;</span></p>
          <p style="font-size:15px;"><span style="color: rgb(0, 0, 0);"><strong><span data-custom-class="heading_2">Information collected from other sources</span></strong>&nbsp;</span></p>
          <p style="font-size: 15px;">
             <span style="color: rgb(89, 89, 89);">
                <strong><em><span style="font-size: 15px;">
                  <span data-custom-class="body_text">In Short:</span></span>&nbsp;</em></strong>
                <span style="font-size: 15px;">
                   <em>
                      <span data-custom-class="body_text">
                         Some information – such as IP address and/or browser and device characteristics – is collected automatically when you visit our Sites.
                      </span>
                   </em>
                   &nbsp;
                </span>
                &nbsp;
             </span>
          </p>
          <p style="font-size: 15px;">
             <span style="color: rgb(89, 89, 89); font-size: 15px;">
                <span data-custom-class="body_text">
                  When you accept cookies, we collect certain information when you use or navigate the Sites. This information does not reveal your specific identity (like your name or contact information) but may include device and usage information, such as your IP address, browser and device characteristics, operating system, language preferences, referring URLs, device name, country, location, information about how and when you use our Sites and other technical information. This information is primarily needed to maintain the security and operation of our Sites, and for our internal analytics and reporting purposes.
                </span>
             </span>
          </p>
          <p style="font-size:15px;"><span style="color: rgb(89, 89, 89);"><br></span></p>
          <p id="infouse" style="font-size:15px;"><span style="color: rgb(0, 0, 0);"><strong><span style="font-size: 19px;"><span data-custom-class="heading_1">2. HOW DO WE USE YOUR INFORMATION?</span></span>&nbsp;</strong>&nbsp;</span></p>
          <p style="font-size: 15px;"><span style="color: rgb(89, 89, 89);"><strong><em><span style="font-size: 15px;"><span data-custom-class="body_text">In Short:</span></span>&nbsp;</em></strong><span style="font-size: 15px;"><em><span data-custom-class="body_text">We process your information for purposes based on legitimate business interests, the fulfillment of our contract with you, compliance with our legal obligations, and/or your consent.</span></em>&nbsp;</span>&nbsp;</span></p>
          <p style="font-size: 15px;">
             <span style="font-size: 15px;">
                <span style="color: rgb(89, 89, 89);">
                   <span data-custom-class="body_text">
                      We use personal information collected via our
                      <span class="block-component"></span>
                      Sites
                      <span class="statement-end-if-in-editor"></span>
                      <span class="block-component"></span>
                      <span class="block-component"></span>
                      for a variety of business purposes described below. We process your personal information for these purposes in reliance on our legitimate business interests ("Business Purposes"), in order to enter into or perform a contract with you ("Contractual"), with your consent ("Consent"), and/or for compliance with our legal obligations ("Legal Reasons"). We indicate the specific processing grounds we rely on next to each purpose listed below.&nbsp;
                   </span>
                </span>
                &nbsp;
             </span>
          </p>
          <p style="font-size:15px;">
             <span style="font-size: 15px;">
                <span style="color: rgb(89, 89, 89);">
                   <span data-custom-class="body_text">
                      We use the information we collect or receive:
                      <span class="block-component"></span>
                      &nbsp;
                   </span>
                </span>
             </span>
             <span class="block-component"></span>
             <span class="block-component"></span>
             <span class="block-component"></span>
             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br><br>
          </p>
          <li>
             <span style="font-size: 15px;">
                <span style="color: rgb(89, 89, 89);">
                   <strong><span data-custom-class="body_text">Fulfill and manage your orders.</span></strong>
                   <span data-custom-class="body_text">
                      &nbsp;We may use your information to fulfill and manage your orders, payments, returns, and exchanges made through the
                      <span class="block-component"></span>
                      Sites
                      <span class="statement-end-if-in-editor"></span>
                      <span class="block-component"></span>
                      <span class="block-component"></span>
                      .
                   </span>
                   <span style="font-size: 15px;">
                      <span style="color: rgb(89, 89, 89);">
                         <span style="font-size: 15px;">
                            <span style="color: rgb(89, 89, 89);">
                               <span style="font-size: 15px;">
                                  <span style="color: rgb(89, 89, 89);">
                                     <span style="font-size: 15px;">
                                        <span style="color: rgb(89, 89, 89);">
                                           <span data-custom-class="body_text">
                                              <span class="statement-end-if-in-editor"></span>
                                              <span class="block-component"></span>
                                              <span class="block-component"></span>
                                              <span class="block-component"></span>
                                              <span class="block-component"></span>
                                              <span class="block-component"></span>
                                              <span class="block-component"></span>
                                              <span class="block-component"></span>
                                              <span class="block-component"></span>
                                              &nbsp;
                                           </span>
                                        </span>
                                     </span>
                                  </span>
                               </span>
                            </span>
                         </span>
                      </span>
                   </span>
                </span>
             </span>
             <br><br>
          </li>
          <li>
             <span style="color: rgb(89, 89, 89); font-size: 15px;">
                <strong><span data-custom-class="body_text">For other Business Purposes.</span></strong>
                <span data-custom-class="body_text">
                   &nbsp;We may use your information for other Business Purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our
                   <span class="block-component"></span>
                   Sites
                   <span class="statement-end-if-in-editor"></span>
                   <span class="block-component"></span>
                   <span class="block-component"></span>
                   , products, services, marketing and your experience.
                </span>
             </span>
          </li>
          <p style="font-size:15px;"><span style="color: rgb(89, 89, 89);"><br></span></p>
          <p id="infoshare" style="font-size:15px;"><span style="color: rgb(0, 0, 0);"><strong><span style="font-size: 19px;"><span data-custom-class="heading_1">3. WILL YOUR INFORMATION BE SHARED WITH ANYONE?</span></span>&nbsp;</strong>&nbsp;</span></p>
          <p style="font-size: 15px;"><span style="color: rgb(89, 89, 89);"><strong><em><span style="font-size: 15px;"><span data-custom-class="body_text">In Short:</span></span>&nbsp;</em></strong><span style="font-size: 15px;"><em><span data-custom-class="body_text">We only share information with your consent, to comply with laws, to protect your rights, or to fulfill business obligations.&nbsp;</span></em>&nbsp;</span>&nbsp;</span></p>
          <div><br></div>
          <div><span style="color: rgb(89, 89, 89); font-size: 15px;"><span data-custom-class="body_text">We may process or share data based on the following legal basis:</span></span></div>
          <ul>
             <li><span data-custom-class="body_text"><span style="color: rgb(89, 89, 89); font-size: 15px;"><strong>Consent:</strong> We may process your data if you have given us specific consent to use your personal information in a specific purpose.&nbsp;</span><br><br></span></li>
             <li><span data-custom-class="body_text"><span style="color: rgb(89, 89, 89); font-size: 15px;"><strong>Legitimate Interests:</strong> We may process your data when it is reasonably necessary to achieve our legitimate business interests.&nbsp;</span><br><br></span></li>
             <li><span data-custom-class="body_text"><span style="color: rgb(89, 89, 89); font-size: 15px;"><strong>Performance of a Contract:&nbsp;</strong>Where we have entered into a contract with you, we may process your personal information to fulfill the terms of our contract.&nbsp;</span><br><br></span></li>
             <li><span data-custom-class="body_text"><span style="color: rgb(89, 89, 89); font-size: 15px;"><strong>Legal Obligations:</strong> We may disclose your information where we are legally required to do so in order to comply with applicable law, governmental requests, a judicial proceeding, court order, or legal process, such as in response to a court order or a subpoena (including in response to public authorities to meet national security or law enforcement requirements).&nbsp;</span><br><br></span></li>
             <li><span style="color: rgb(89, 89, 89); font-size: 15px;"><span data-custom-class="body_text"><strong>Vital Interests:</strong> We may disclose your information where we believe it is necessary to investigate, prevent, or take action regarding potential violations of our policies, suspected fraud, situations involving potential threats to the safety of any person and illegal activities, or as evidence in litigation in which we are involved.</span></span></li>
          </ul>
          <p style="font-size:15px;">
             <span style="font-size: 15px;"><span style="color: rgb(89, 89, 89);"><span data-custom-class="body_text">More specifically, we may need to process your data or share your personal information in the following situations:</span></span></span><span style="font-size: 15px;">&nbsp;</span>
             <span style="font-size: 15px;">
                <span style="color: rgb(89, 89, 89);">
                   <span data-custom-class="body_text">
                      <span class="block-component"></span>
                      &nbsp;
                   </span>
                </span>
                &nbsp;
             </span>
             <br><br>
          </p>
          <li>
             <span style="font-size: 15px;">
                <span style="color: rgb(89, 89, 89);">
                   <strong><span data-custom-class="body_text">Business Transfers.</span></strong>
                   <span data-custom-class="body_text">
                      &nbsp;We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business to another company.
                      <span class="block-component"></span>
                      &nbsp;
                   </span>
                </span>
                &nbsp;
             </span>
             <br><br>
          </li>
          <li>
             <span style="font-size: 15px;">
                <span style="color: rgb(89, 89, 89);">
                   <strong><span data-custom-class="body_text">Third-Party Advertisers.</span></strong>
                   <span data-custom-class="body_text">
                      &nbsp;We may use third-party advertising companies to serve ads when you visit the
                      <span class="block-component"></span>
                      Sites
                      <span class="statement-end-if-in-editor"></span>
                      <span class="block-component"></span>
                      <span class="block-component"></span>
                      . These companies may use information about your visits to our Website(s) and other websites that are contained in web cookies and other tracking technologies in order to provide advertisements about goods and services of interest to you.
                      <span class="block-component"></span>
                      See our Cookie Policy:
                      <span class="block-component"></span>
                      <span class="question"><a class="text-sm" href="javascript:window.Metomic('ConsentManager:show')">Manage cookies</a></span>
                      <span class="block-component"></span>
                      for further information.
                   </span>
                   <span style="font-size: 15px;">
                      <span style="color: rgb(89, 89, 89);">
                         <span data-custom-class="body_text">
                            &nbsp;
                            <span class="statement-end-if-in-editor"></span>
                            <span class="statement-end-if-in-editor"></span>
                            <span class="block-component"></span>
                            &nbsp;
                         </span>
                      </span>
                      &nbsp;
                   </span>
                   &nbsp;
                </span>
                <span class="block-component"></span>
                &nbsp;
             </span>
             <span style="font-size: 15px;">
                <span style="color: rgb(89, 89, 89);">
                   <span data-custom-class="body_text">
                      <span class="block-component"></span>
                      <span class="block-component"></span>
                   </span>
                   &nbsp;
                </span>
                &nbsp;
             </span>
          </li>
          <div>
             <span style="color: rgb(89, 89, 89);">
                <span class="block-component"><span data-custom-class="body_text"></span></span>
             </span>
             <span style="color: rgb(89, 89, 89); font-size: 15px;">
                <span style="font-size: 15px;">
                   <span style="color: rgb(89, 89, 89);">
                      <span style="font-size: 15px;">
                         <span style="color: rgb(89, 89, 89);">
                            <span class="block-component"><span data-custom-class="heading_1"></span></span>
                         </span>
                      </span>
                   </span>
                </span>
             </span>
          </div>
          <div><br></div>
          <div><span id="cookies" style="color: rgb(0, 0, 0);"><strong><span style="font-size: 19px;"><span data-custom-class="heading_1">4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</span></span></strong></span></div>
          <p style="font-size: 15px;"><span style="color: rgb(89, 89, 89);"><strong><em><span style="font-size: 15px;"><span data-custom-class="body_text">In Short:</span></span>&nbsp;</em></strong><span style="font-size: 15px;"><em><span data-custom-class="body_text">We may use cookies and other tracking technologies to collect and store your information.</span></em>&nbsp;</span>&nbsp;</span></p>
          <p style="font-size: 15px;">
             <span style="color: rgb(89, 89, 89); font-size: 15px;">
                <span data-custom-class="body_text">
                   We may use cookies and similar tracking technologies (like web beacons and pixels) to access or store information. Specific information about how we use such technologies and how you can refuse certain cookies is set out in our Cookie Policy
                   <span class="block-component"></span>
                   :
                   <span class="question">
                     <a class="text-sm" href="javascript:window.Metomic('ConsentManager:show')">Manage cookies</a>
                   </span>
                </span>
             </span>
             <span data-custom-class="body_text">
                <span style="font-size: 15px; color: rgb(89, 89, 89);">
                   <span class="block-component"></span>
                   .
                </span>
                <span style="color: rgb(89, 89, 89); font-size: 15px;">
                   <span style="font-size: 15px;">
                      <span style="color: rgb(89, 89, 89);">
                         <span style="font-size: 15px;">
                            <span style="color: rgb(89, 89, 89);">
                               <span data-custom-class="body_text">
                                  <span class="statement-end-if-in-editor"></span>
                                  <span class="block-component"></span>
                                  <span class="block-component"></span>
                                  <span class="block-component"></span>
                                  &nbsp;
                               </span>
                            </span>
                         </span>
                      </span>
                   </span>
                </span>
             </span>
             <span style="color: rgb(89, 89, 89); font-size: 15px;">
                <span style="color: rgb(89, 89, 89); font-size: 15px;">
                   <span style="color: rgb(89, 89, 89); font-size: 15px;">
                      <span style="color: rgb(89, 89, 89); font-size: 15px;">
                         <span style="color: rgb(89, 89, 89); font-size: 15px;">
                            <span style="font-size: 15px;">
                               <span style="color: rgb(89, 89, 89);">
                                  <span style="font-size: 15px;">
                                     <span style="color: rgb(89, 89, 89);">
                                        <span data-custom-class="body_text">
                                           <span class="block-component"></span>
                                        </span>
                                        &nbsp;
                                     </span>
                                  </span>
                               </span>
                            </span>
                         </span>
                      </span>
                   </span>
                </span>
             </span>
          </p>
          <p style="font-size:15px;"><span style="color: rgb(89, 89, 89);"><br></span></p>
          <p id="inforetain" style="font-size:15px;"><span style="color: rgb(0, 0, 0);"><strong><span style="font-size: 19px;"><span data-custom-class="heading_1">5. HOW LONG DO WE KEEP YOUR INFORMATION?</span></span>&nbsp;</strong></span></p>
          <p style="font-size: 15px;"><span style="color: rgb(89, 89, 89);"><strong><em><span style="font-size: 15px;"><span data-custom-class="body_text">In Short:</span></span>&nbsp;</em></strong><span style="font-size: 15px;"><em><span data-custom-class="body_text">We keep your information for as long as necessary to fulfill the purposes outlined in this privacy policy unless otherwise required by law.</span></em>&nbsp;</span>&nbsp;</span></p>
          <p style="font-size: 15px;">
             <span style="font-size: 15px;">
                <span style="color: rgb(89, 89, 89);">
                   <span data-custom-class="body_text">
                      We will only keep your personal information for as long as it is necessary for the purposes set out in this privacy policy, unless a longer retention period is required or permitted by law (such as tax, accounting or other legal requirements). No purpose in this policy will require us keeping your personal information for longer than
                      <span class="block-component"></span>
                      <span class="question">1 year</span>
                      <span class="statement-end-if-in-editor"></span>
                      .
                   </span>
                </span>
             </span>
          </p>
          <p style="font-size: 15px;"><span style="color: rgb(89, 89, 89); font-size: 15px;"><span data-custom-class="body_text">When we have no ongoing legitimate business need to process your personal information, we will either delete or anonymize it, or, if this is not possible (for example, because your personal information has been stored in backup archives), then we will securely store your personal information and isolate it from any further processing until deletion is possible.</span></span></p>
          <p style="font-size:15px;"><span style="color: rgb(89, 89, 89);"><br></span></p>
          <p id="infosafe" style="font-size:15px;"><span style="color: rgb(0, 0, 0);"><strong><span style="font-size: 19px;"><span data-custom-class="heading_1">6. HOW DO WE KEEP YOUR INFORMATION SAFE?&nbsp;</span></span></strong></span></p>
          <p style="font-size: 15px;"><span style="color: rgb(89, 89, 89);"><strong><em><span style="font-size: 15px;"><span data-custom-class="body_text">In Short:</span></span>&nbsp;</em></strong><span style="font-size: 15px;"><em><span data-custom-class="body_text">We aim to protect your personal information through a system of organisational and technical security measures.</span></em>&nbsp;</span></span></p>
          <p style="font-size: 15px;">
             <span style="color: rgb(89, 89, 89); font-size: 15px;">
                <span data-custom-class="body_text">
                   We have implemented appropriate technical and organisational security measures designed to protect the security of any personal information we process. However, please also remember that we cannot guarantee that the internet itself is 100% secure. Although we will do our best to protect your personal information, transmission of personal information to and from our
                   <span class="block-component"></span>
                   Sites
                   <span class="statement-end-if-in-editor"></span>
                   <span class="block-component"></span>
                   <span class="block-component"></span>
                   is at your own risk. You should only access the services within a secure environment.
                   <span class="block-component"></span>
                   &nbsp;
                </span>
             </span>
          </p>
          <p style="font-size:15px;"><span style="color: rgb(89, 89, 89);"><br></span></p>
          <p id="infominors" style="font-size:15px;"><span style="color: rgb(0, 0, 0);"><strong><span style="font-size: 19px;"><span data-custom-class="heading_1">7. DO WE COLLECT INFORMATION FROM MINORS?</span></span></strong></span></p>
          <p style="font-size: 15px;"><span style="color: rgb(89, 89, 89);"><strong><em><span style="font-size: 15px;"><span data-custom-class="body_text">In Short:</span></span>&nbsp;</em></strong><span style="font-size: 15px;"><em><span data-custom-class="body_text">We do not knowingly collect data from or market to children under 18 years of age.</span></em></span></span></p>
          <p style="font-size: 15px;">
             <span style="color: rgb(89, 89, 89); font-size: 15px;">
                <span data-custom-class="body_text">
                   We do not knowingly solicit data from or market to children under 18 years of age. By using the
                   <span class="block-component"></span>
                   Sites
                   <span class="statement-end-if-in-editor"></span>
                   <span class="block-component"></span>
                   <span class="block-component"></span>
                   , you represent that you are at least 18 or that you are the parent or guardian of such a minor and consent to such minor dependent’s use of the
                   <span class="block-component"></span>
                   Sites
                   <span class="statement-end-if-in-editor"></span>
                   <span class="block-component"></span>
                   <span class="block-component"></span>
                   . If we learn that personal information from users less than 18 years of age has been collected, we will deactivate the account and take reasonable measures to promptly delete such data from our records. If you become aware of any data we have collected from children under age 18, please contact us at
                   <span class="block-component"></span>
                   <span class="question">info@firstoptionsfertility.ie</span>
                   <span class="else-block"></span>
                   .
                </span>
                <span style="color: rgb(89, 89, 89); font-size: 15px;">
                   <span data-custom-class="body_text">
                      <span class="statement-end-if-in-editor"></span>
                      &nbsp;
                   </span>
                </span>
             </span>
          </p>
          <p style="font-size:15px;"><span style="color: rgb(89, 89, 89);"><br></span></p>
          <p id="privacyrights" style="font-size:15px;"><span style="color: rgb(0, 0, 0);"><strong><span style="font-size: 19px;"><span data-custom-class="heading_1">8. WHAT ARE YOUR PRIVACY RIGHTS?</span></span>&nbsp;</strong></span></p>
          <p style="font-size: 15px;"><span style="color: rgb(89, 89, 89);"><strong><em><span style="font-size: 15px;"><span data-custom-class="body_text">In Short:</span></span>&nbsp;</em></strong><span style="font-size: 15px;"><span data-custom-class="body_text"><em>In some regions, such as the European Economic Area, you have rights that allow you greater access to and control over your personal information. You may review, change, or terminate your account at any time.</em></span></span></span></p>
          <p style="font-size: 15px;"><span style="font-size: 15px;"><span style="color: rgb(89, 89, 89);"><span data-custom-class="body_text">In some regions (like the European Economic Area), you have certain rights under applicable data protection laws. These may include the right (i) to request access and obtain a copy of your personal information, (ii) to request rectification or erasure; (iii) to restrict the processing of your personal information; and (iv) if applicable, to data portability. In certain circumstances, you may also have the right to object to the processing of your personal information. To make such a request, please use the&nbsp;</span></span></span><span style="color: rgb(48, 48, 241);"><span data-custom-class="body_text"><a data-custom-class="link" href="#contact"><span style="font-size: 15px;">contact details</span></a></span></span><span style="font-size: 15px;"><span style="color: rgb(89, 89, 89);"><span data-custom-class="body_text">&nbsp;provided below. We will consider and act upon any request in accordance with applicable data protection laws.</span></span>&nbsp;</span></p>
          <p style="font-size: 15px;"><span style="font-size: 15px;"><span style="color: rgb(89, 89, 89);"><span data-custom-class="body_text">If we are relying on your consent to process your personal information, you have the right to withdraw your consent at any time. Please note however that this will not affect the lawfulness of the processing before its withdrawal.</span></span></span></p>
          <p style="font-size: 15px;">
             <span style="font-size: 15px;"><span style="color: rgb(89, 89, 89);"><span data-custom-class="body_text">If you are resident in the European Economic Area and you believe we are unlawfully processing your personal information, you also have the right to complain to your local data protection supervisory authority. You can find their contact details here:</span></span>&nbsp;</span><span data-custom-class="body_text"><span style="color: rgb(48, 48, 241);"><a data-custom-class="link" href="http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm" target="_blank"><span style="font-size: 15px;">http://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm</span></a>&nbsp;</span></span>
             <span style="font-size: 15px;">
                <span style="color: rgb(89, 89, 89);">
                   <span class="block-component"><span data-custom-class="body_text"></span></span>
                   <span class="block-component"></span>
                </span>
             </span>
             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </p>
          <p style="font-size: 15px;">
             <span style="font-size: 15px;">
                <span style="color: rgb(89, 89, 89);">
                   <strong><u><span data-custom-class="body_text">Cookies and similar technologies:</span></u>&nbsp;</strong>
                   <span data-custom-class="body_text">
                      &nbsp;Most Web browsers are set to accept cookies by default. If you prefer, you can usually choose to set your browser to remove cookies and to reject cookies. If you choose to remove cookies or reject cookies, this could affect certain features or services of our
                      <span class="block-component"></span>
                      Sites
                      <span class="statement-end-if-in-editor"></span>
                      <span class="block-component"></span>
                      <span class="block-component"></span>
                      . To opt-out of interest-based advertising by advertisers on our
                      <span class="block-component"></span>
                      Sites
                      <span class="statement-end-if-in-editor"></span>
                      <span class="block-component"></span>
                      <span class="block-component"></span>
                      visit&nbsp;
                   </span>
                </span>
             </span>
             <span style="color: rgb(48, 48, 241);"><span data-custom-class="body_text"><a href="http://www.aboutads.info/choices/" target="_blank"><span style="font-size: 15px;">http://www.aboutads.info/choices/</span></a></span></span>
             <span style="font-size: 15px;">
                <span style="color: rgb(89, 89, 89);">
                   <span data-custom-class="body_text">
                      .
                      <span class="block-component"></span>
                      For further information, please see our Cookie Policy:
                      <span class="question"><a href="https://firstoptionsfertility.ie/cookie-policy" target="_blank" data-custom-class="link">https://firstoptionsfertility.ie/cookie-policy</a></span>
                      .
                      <span class="block-component"></span>
                      <span style="font-size: 15px;">
                         <span style="color: rgb(89, 89, 89);">
                            <span style="font-size: 15px;">
                               <span style="color: rgb(89, 89, 89);">
                                  <span style="font-size: 15px;">
                                     <span style="color: rgb(89, 89, 89);">
                                        <span class="statement-end-if-in-editor"></span>
                                     </span>
                                  </span>
                                  &nbsp;
                               </span>
                            </span>
                         </span>
                      </span>
                      <span class="block-component"></span>
                   </span>
                </span>
             </span>
          </p>
          <p id="DNT" style="font-size:15px;"><span style="color: rgb(0, 0, 0);"><strong><span style="font-size: 19px;"><span data-custom-class="heading_1">9. CONTROLS FOR DO-NOT-TRACK FEATURES</span></span>&nbsp;</strong>&nbsp;</span></p>
          <p style="font-size: 15px;"><span style="color: rgb(89, 89, 89);"><span style="font-size: 15px;"><span data-custom-class="body_text">Most web browsers and some mobile operating systems and mobile applications include a Do-Not-Track (“DNT”) feature or setting you can activate to signal your privacy preference not to have data about your online browsing activities monitored and collected. No uniform technology standard for recognizing and implementing DNT signals has been finalized. As such, we do not currently respond to DNT browser signals or any other mechanism that automatically communicates your choice not to be tracked online. If a standard for online tracking is adopted that we must follow in the future, we will inform you about that practice in a revised version of this Privacy Policy.</span></span>&nbsp;</span></p>
          <div><br></div>
          <p id="caresidents" style="font-size:15px;"><span style="color: rgb(0, 0, 0);"><strong><span style="font-size: 19px;"><span data-custom-class="heading_1">10. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</span></span></strong></span></p>
          <p style="font-size: 15px;"><span style="color: rgb(89, 89, 89);"><strong><em><span style="font-size: 15px;"><span data-custom-class="body_text">In Short:</span></span>&nbsp;</em></strong><span style="font-size: 15px;"><em><span data-custom-class="body_text">Yes, if you are a resident of California, you are granted specific rights regarding access to your personal information.&nbsp;</span></em>&nbsp;</span></span></p>
          <p style="font-size: 15px;"><span style="font-size: 15px;"><span style="color: rgb(89, 89, 89);"><span data-custom-class="body_text">California Civil Code Section 1798.83, also known as the “Shine The Light” law, permits our users who are California residents to request and obtain from us, once a year and free of charge, information about categories of personal information (if any) we disclosed to third parties for direct marketing purposes and the names and addresses of all third parties with which we shared personal information in the immediately preceding calendar year. If you are a California resident and would like to make such a request, please submit your request in writing to us using the contact information provided below.</span></span>&nbsp;</span></p>
          <p style="font-size: 15px;">
             <span style="color: rgb(89, 89, 89); font-size: 15px;">
                <span data-custom-class="body_text">
                   If you are under 18 years of age, reside in California, and have a registered account with the
                   <span class="block-component"></span>
                   Sites
                   <span class="statement-end-if-in-editor"></span>
                   <span class="block-component"></span>
                   <span class="block-component"></span>
                   , you have the right to request removal of unwanted data that you publicly post on the
                   <span class="block-component"></span>
                   Sites
                   <span class="statement-end-if-in-editor"></span>
                   <span class="block-component"></span>
                   <span class="block-component"></span>
                   . To request removal of such data, please contact us using the contact information provided below, and include the email address associated with your account and a statement that you reside in California. We will make sure the data is not publicly displayed on the
                   <span class="block-component"></span>
                   Sites
                   <span class="statement-end-if-in-editor"></span>
                   <span class="block-component"></span>
                   <span class="block-component"></span>
                   , but please be aware that the data may not be completely or comprehensively removed from our systems.
                </span>
             </span>
          </p>
          <p style="font-size:15px;"><span style="color: rgb(89, 89, 89);"><br></span></p>
          <p id="policyupdates" style="font-size:15px;"><span style="color: rgb(0, 0, 0);"><strong><span style="font-size: 19px;"><span data-custom-class="heading_1">11. DO WE MAKE UPDATES TO THIS POLICY?</span></span></strong></span></p>
          <p style="font-size: 15px;"><span style="color: rgb(89, 89, 89);"><strong><em><span style="font-size: 15px;"><span data-custom-class="body_text">In Short:</span></span>&nbsp;</em></strong><span style="font-size: 15px;"><em><span data-custom-class="body_text">Yes, we will update this policy as necessary to stay compliant with relevant laws.</span></em></span></span></p>
          <p style="font-size: 15px;"><span style="color: rgb(89, 89, 89); font-size: 15px;"><span data-custom-class="body_text">We may update this privacy policy from time to time. The updated version will be indicated by an updated “Revised” date and the updated version will be effective as soon as it is accessible. If we make material changes to this privacy policy, we may notify you either by prominently posting a notice of such changes or by directly sending you a notification. We encourage you to review this privacy policy frequently to be informed of how we are protecting your information.&nbsp;</span></span></p>
          <p style="font-size:15px;"><span style="color: rgb(89, 89, 89);"><br></span></p>
          <p id="contact" style="font-size:15px;"><span style="color: rgb(0, 0, 0);"><strong><span style="font-size: 19px;"><span data-custom-class="heading_1">12. HOW CAN YOU CONTACT US ABOUT THIS POLICY?</span></span></strong></span></p>
          <p style="font-size: 15px;">
             <span style="color: rgb(89, 89, 89); font-size: 15px;">
                <span data-custom-class="body_text">
                   If you have questions or comments about this policy, you may
                   <span class="block-component"></span>
                   email us at
                   <span class="question">info@firstoptionsfertility.ie</span>
                   <span class="statement-end-if-in-editor"></span>
                   or by post to:
                </span>
             </span>
          </p>
          <div>
             <span style="color: rgb(89, 89, 89);">
                <span class="question"><span style="font-size: 15px;"><span data-custom-class="body_text">FirstOptionsFertility</span></span></span>
                <span data-custom-class="body_text">
                   <span style="font-size: 15px;">
                      <span class="block-component"></span>
                   </span>
                </span>
             </span>
          </div>
          <div>
             <span data-custom-class="body_text">
                <span style="color: rgb(89, 89, 89);">
                   <span style="font-size: 15px;">
                      <span class="question">Lambay Road</span>
                      <span class="block-component"></span>
                   </span>
                </span>
             </span>
          </div>
          <div>
             <span data-custom-class="body_text">
                <span style="font-size: 15px;">
                   <span data-custom-class="body_text">
                      <span style="color: rgb(89, 89, 89);">
                         <span class="question">Dublin</span>
                         ,
                         <span class="block-component"></span>
                         <span class="question">Leinster</span>
                         <span class="statement-end-if-in-editor"></span>
                         <span class="question">D09TH44</span>
                         <span class="block-component"></span>
                      </span>
                   </span>
                   <span class="block-component"></span>
                </span>
             </span>
             <span data-custom-class="body_text">
                <span style="font-size: 15px;">
                   <span class="question">Ireland</span>
                   <span class="statement-end-if-in-editor"></span>
                   <span data-custom-class="body_text">
                      <span style="color: rgb(89, 89, 89);">
                         <span class="statement-end-if-in-editor"></span>
                         <span class="statement-end-if-in-editor"></span>
                      </span>
                   </span>
                </span>
             </span>
             <span style="color: rgb(89, 89, 89);">
                <span style="font-size: 15px;">
                   <span data-custom-class="body_text">
                      <span class="block-component"></span>
                   </span>
                </span>
             </span>
             <span class="block-component"><span data-custom-class="body_text"></span></span>
          </div>
          <p style="font-size:15px;"><span style="color: rgb(89, 89, 89);"><br></span></p>
          <p id="contact" style="font-size:15px;"><strong><span data-custom-class="heading_1">HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?</span></strong></p>
          <div>
             <span data-custom-class="body_text">
                Based on the applicable laws of your country, you may have the right to request access to the personal information we collect from you, change that information, or delete it in some circumstances. To request to review, update, or delete your personal information, please
                <span class="block-component"></span>
                submit a request form by clicking <span style="color: rgb(48, 48, 241);"><span data-custom-class="body_text"><span style="font-size: 15px;"><a data-custom-class="link" href="https://app.termly.io/notify/6fccf353-f1c4-4965-abb3-4268265859e9" rel="noopener noreferrer" target="_blank">here</a></span></span></span>
                <span class="statement-end-if-in-editor"></span>
                . We will respond to your request within 30 days.
             </span>
          </div>
       </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'TermsPrivacy',
  components: {
  }
}
</script>

<style scoped>
.heading_1 {
  font-size: 24px;
}
</style>
